import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

export default function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsVisible(scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8, y: 100 }}
      animate={{ 
        opacity: isVisible ? 1 : 0, 
        scale: isVisible ? 1 : 0.8, 
        y: isVisible ? 0 : 100 
      }}
      transition={{ 
        duration: window.innerWidth >= 768 ? 0.3 : 0.15,
        ease: "easeOut" 
      }}
      className="fixed bottom-4 right-4 z-50"
      style={{ pointerEvents: isVisible ? 'auto' : 'none' }}
    >
      <Link
        to="/etude-gratuite"
        className="group relative block"
      >
        <div className="relative bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-4 py-3 rounded-full shadow-lg hover:shadow-xl transition-all cursor-pointer">
          {/* Petite bulle en haut à droite */}
          <span 
            className="absolute -top-0.5 -right-0.5 w-3 h-3 bg-gradient-to-r from-emerald-400 to-teal-400 rounded-full border-2 border-white shadow-sm animate-ping"
          ></span>
          
          {/* Effet de pulsation - Desktop only */}
          <span 
            className="absolute inset-0 rounded-full bg-gradient-to-r from-emerald-400 to-teal-400 opacity-20"
            style={{
              animation: window.innerWidth >= 768 ? 'ping 2s infinite' : 'none'
            }}
          ></span>
          
          <div className="relative flex items-center gap-2">
            <i className="ri-flashlight-line text-lg"></i>
            <span className="text-sm font-bold whitespace-nowrap">Étude gratuite</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
